import {TOGGLE_MENU} from './constants'

export function toggleMenu () {
  return {
    type: TOGGLE_MENU,
  }
}
